export function ds24_checkout_url() {
  return __CHECKOUT_URL__;
}
